module.exports = __webpack_public_path__ + "static/media/30-1.5146bc28.mp3";